/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboBranchConfigBadRequestResponse,
  BboBranchConfigFailureResponseResponse,
  BboBranchConfigForbiddenResponse,
  BboBranchConfigUnauthorizedResponse,
  BranchConfigDataResponse,
  BranchConfigDataV2Response,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Branch configuration detail based on its type
 */
export const getBranchConfig = (
  type: 'DMB' | 'IND' | 'SP' | 'metadata' | 'menu' | 'menu-v2' | 'currency-types',
  signal?: AbortSignal,
) => {
  return customInstance<BranchConfigDataResponse>({
    url: `/BboBranchConfigService/v1/branch-config/${type}`,
    method: 'get',
    signal,
  });
};

export const getGetBranchConfigQueryKey = (
  type: 'DMB' | 'IND' | 'SP' | 'metadata' | 'menu' | 'menu-v2' | 'currency-types',
) => {
  return [`/BboBranchConfigService/v1/branch-config/${type}`] as const;
};

export const getGetBranchConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getBranchConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  type: 'DMB' | 'IND' | 'SP' | 'metadata' | 'menu' | 'menu-v2' | 'currency-types',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranchConfig>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBranchConfigQueryKey(type);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranchConfig>>> = ({ signal }) =>
    getBranchConfig(type, signal);

  return { queryKey, queryFn, enabled: !!type, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBranchConfig>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBranchConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getBranchConfig>>>;
export type GetBranchConfigQueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Branch configuration detail based on its type
 */
export const useGetBranchConfig = <
  TData = Awaited<ReturnType<typeof getBranchConfig>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  type: 'DMB' | 'IND' | 'SP' | 'metadata' | 'menu' | 'menu-v2' | 'currency-types',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranchConfig>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBranchConfigQueryOptions(type, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Branch configuration detail based on its type
 */
export const getBranchConfigV2 = (branchType: 'DMB' | 'IND' | 'SP', signal?: AbortSignal) => {
  return customInstance<BranchConfigDataV2Response>({
    url: `/BboBranchConfigService/v2/branch-config/${branchType}`,
    method: 'get',
    signal,
  });
};

export const getGetBranchConfigV2QueryKey = (branchType: 'DMB' | 'IND' | 'SP') => {
  return [`/BboBranchConfigService/v2/branch-config/${branchType}`] as const;
};

export const getGetBranchConfigV2QueryOptions = <
  TData = Awaited<ReturnType<typeof getBranchConfigV2>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranchConfigV2>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBranchConfigV2QueryKey(branchType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBranchConfigV2>>> = ({ signal }) =>
    getBranchConfigV2(branchType, signal);

  return { queryKey, queryFn, enabled: !!branchType, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBranchConfigV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBranchConfigV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getBranchConfigV2>>
>;
export type GetBranchConfigV2QueryError = ErrorType<
  | BboBranchConfigBadRequestResponse
  | BboBranchConfigUnauthorizedResponse
  | BboBranchConfigForbiddenResponse
  | BboBranchConfigFailureResponseResponse
>;

/**
 * @summary Branch configuration detail based on its type
 */
export const useGetBranchConfigV2 = <
  TData = Awaited<ReturnType<typeof getBranchConfigV2>>,
  TError = ErrorType<
    | BboBranchConfigBadRequestResponse
    | BboBranchConfigUnauthorizedResponse
    | BboBranchConfigForbiddenResponse
    | BboBranchConfigFailureResponseResponse
  >,
>(
  branchType: 'DMB' | 'IND' | 'SP',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getBranchConfigV2>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBranchConfigV2QueryOptions(branchType, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
